<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('thesis.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('thesis.pageTitle'),
            href: '/thesis'
          },
          {
            text: $t('add_new'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <div class="row">
                <div class="col-md-8">
                  <form>
                    <fieldset>
                      <legend>{{ $t('thesis.registration') }}</legend>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 required ts-ml-16 ts-mt-1">{{
                              $t('thesis.registrationDate')
                            }}</label>
                            <div class="col-md-7">
                              <ts-date-picker-input
                                v-model="model.registration_date"
                                style="width: 100%"
                                :class="{
                                  'is-invalid': errors.has('registration_date')
                                }"
                              ></ts-date-picker-input>
                              <div
                                class="validate"
                                v-if="errors.has('registration_date')"
                              >
                                {{ errors.first('registration_date') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 required ts-ml-6 ts-mt-1">{{
                              $t('thesis.startDate')
                            }}</label>
                            <div class="col-md-7">
                              <ts-date-picker-input
                                v-model="model.start_date"
                                style="width: 100%"
                                :class="{
                                  'is-invalid': errors.has('start_date')
                                }"
                              ></ts-date-picker-input>
                              <div
                                class="validate"
                                v-if="errors.has('start_date')"
                              >
                                {{ errors.first('start_date') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-16 col-lg-6 col-md-12">
                          <div class="ts-mt-2 row">
                            <label
                              class="col-md-3 form-col-label control-label required ts-ml-16 ts-mt-2"
                              >{{ $t('thesis.academicYear') }}</label
                            >
                            <div class="col-md-7">
                              <a-select
                                v-model="model.ac_year_id"
                                :options="ac_year_list"
                                @change="acYearChange"
                                :class="{
                                  'is-invalid': errors.has('ac_year_id')
                                }"
                              ></a-select>
                              <div
                                class="validate"
                                v-if="errors.has('ac_year_id')"
                              >
                                {{ errors.first('ac_year_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 ts-ml-6 ts-mt-1">{{
                              $t('thesis.defenseDate')
                            }}</label>
                            <div class="col-md-7">
                              <ts-date-picker-input
                                v-model="model.presentation_date"
                                style="width: 100%"
                                :class="{
                                  'is-invalid': errors.has('presentation_date')
                                }"
                              ></ts-date-picker-input>
                              <div
                                class="validate"
                                v-if="errors.has('presentation_date')"
                              >
                                {{ errors.first('presentation_date') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-lg-6 col-md-12">
                          <div class="ts-mt-2 row">
                            <label class="col-form-label col-md-3 required ts-ml-16 ts-mt-1">{{
                              $t('thesis.major')
                            }}</label>
                            <div class="col-md-7">
                              <a-select
                                style="width: 100%"
                                v-model="model.acps_id"
                                :options="sub_programs"
                                :class="{
                                  'is-invalid': errors.has('acps_id')
                                }"
                                :show-search="true"
                                :filter-option="
                                  (input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                "
                                @change="onSubChange"
                                :disabled="!model.ac_year_id"
                              ></a-select>
                              <div
                                class="validate"
                                v-if="errors.has('acps_id')"
                              >
                                {{ errors.first('acps_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 required ts-ml-6 ts-mt-1">{{
                              $t('thesis.endDate')
                            }}</label>
                            <div class="col-md-7">
                              <ts-date-picker-input
                                v-model="model.end_date"
                                style="width: 100%"
                                :class="{
                                  'is-invalid': errors.has('end_date')
                                }"
                              ></ts-date-picker-input>
                              <div
                                class="validate"
                                v-if="errors.has('end_date')"
                              >
                                {{ errors.first('end_date') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 required ts-ml-16 ts-mt-1">{{
                              $t('thesis.degree')
                            }}</label>
                            <div class="col-md-7">
                              <ts-loading-banner :loading="filterSub">
                                <a-select
                                  style="width: 100%"
                                  v-model="model.level_id"
                                  :class="{
                                    'is-invalid': errors.has('level_id')
                                  }"
                                  :options="levels"
                                  :filter-option="
                                    (input, option) =>
                                      option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                  "
                                  @change="levelChange"
                                ></a-select>
                              </ts-loading-banner>
                              <div
                                class="validate"
                                v-if="errors.has('level_id')"
                              >
                                {{ errors.first('level_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 ts-ml-6 ts-mt-1">{{
                              $t('thesis.professor')
                            }}</label>
                            <div class="col-md-7">
                              <a-select
                                v-model="model.teacher_id"
                                :options="teacherLists"
                                :show-search="true"
                                :filter-option="
                                  (input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                "
                              ></a-select>
                              <div
                                class="validate"
                                v-if="errors.has('teacher_id')"
                              >
                                {{ errors.first('teacher_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 ts-ml-16 ts-mt-1">{{
                              $t('thesis.acTerm')
                            }}</label>
                            <div class="col-md-7">
                              <ts-loading-banner :loading="filterLevel">
                                <a-select
                                  style="width: 100%"
                                  v-model="model.ac_term_id"
                                  :options="ac_terms"
                                  :class="{
                                    'is-invalid': errors.has('ac_term_id')
                                  }"
                                  :show-search="true"
                                  :filter-option="
                                    (input, option) =>
                                      option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                  "
                                  @change="acTermChange"
                                ></a-select>
                              </ts-loading-banner>
                              <div
                                class="validate"
                                v-if="errors.has('ac_term_id')"
                              >
                                {{ errors.first('ac_term_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row ts-mt-2">
                            <label class="col-form-label col-md-3 ts-ml-6 ts-mt-1">{{
                              $t('thesis.subjectClass')
                            }}</label>
                            <div class="col-md-7">
                              <ts-loading-banner :loading="filterClass">
                                <a-select
                                  style="width: 100%"
                                  v-model="model.class_id"
                                  :options="class_options"
                                  :class="{
                                    'is-invalid': errors.has('class_id')
                                  }"
                                  :show-search="true"
                                  :filter-option="
                                    (input, option) =>
                                      option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                  "
                                ></a-select>
                              </ts-loading-banner>
                              <div
                                class="validate"
                                v-if="errors.has('class_id')"
                              >
                                {{ errors.first('class_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row ts-mt-2">
                            <label class="col-form-label required ts-ml-16 ts-mt-1" style="width:13.3%">{{
                              $t('thesis.topic')
                            }}</label>
                            <div style="width:75%;">
                              <a-select
                                v-model="model.topic_id"
                                :options="topics"
                                :show-search="true"
                                :filter-option="
                                  (input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                "
                              >
                              </a-select>
                              <div
                                class="validate"
                                v-if="errors.has('topic_id')"
                              >
                                {{ errors.first('topic_id') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <br />
                  </form>
                </div>
                <div class="col-md-4">
                  <form>
                    <fieldset>
                      <legend>
                        {{ $t('thesis.committee') }}
                      </legend>
                      <div class="row">
                        <div class="col-md-12">
                          <div id="container-table">
                            <table class="table ui-table table-hover">
                              <thead>
                                <tr>
                                  <th style="width: 50%">
                                    {{ $t('thesis.employeeName') }}
                                  </th>
                                  <th style="width: 50%">
                                    {{ $t('thesis.description') }}
                                  </th>
                                  <th style="width: 2%" class="text-center">
                                    <a href="#" class="text-primary">
                                      <i
                                        class="fas fa-spinner spin"
                                        v-if="ready_fetch"
                                      ></i>
                                      <i
                                        class="fa fa-plus"
                                        v-else
                                        @click.prevent="addNewRow"
                                      ></i>
                                    </a>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in model.staff_id_list"
                                  :key="index"
                                >
                                  <td>
                                    <input
                                      v-model="item.committee_name"
                                      type="text"
                                      step="any"
                                      class="form-control only-border-bottom"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      v-model="item.remark"
                                      type="text"
                                      step="any"
                                      class="form-control only-border-bottom"
                                    />
                                  </td>
                                  <td class="text-center">
                                    <a
                                      href="#"
                                      class="text-danger"
                                      @click.prevent="removeRow(item)"
                                    >
                                      <i class="fa fa-trash"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <student-list v-model="model" ref="studentList" />
                  <div class="validate" v-if="errors.has('student_id_list')">
                    {{ errors.first('student_id_list') }}
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12 text-right">
                  <ts-button
                    class="btn-primary mr-2"
                    :waiting="saving"
                    @click.prevent="update"
                  >
                    {{ $t('update') }}
                  </ts-button>
                  <ts-button
                    class="btn-default"
                    @click="$router.push({ name: 'thesis' })"
                  >
                    {{ $t('cancel') }}
                  </ts-button>
                </div>
              </div>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import StudentList from './components/student-list'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'thesis-eidt',
  components: {
    StudentList
  },
  data () {
    return {
      loading: false,
      saving: false,
      errors: new Errors(),
      filterSub: false,
      filterClass: false,
      ready_fetch: false,
      filterLevel: false,
      topics: [],
      teacherLists: [],
      ac_year_list: [],
      sub_programs: [],
      ac_terms: [],
      levels: [],
      class_options: [],
      model: {
        thesis_reg_id: null,
        registration_date: moment().format('DD-MM-YYYY'),
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        teacher_id: null,
        ac_year_id: null,
        ac_term_id: null,
        presentation_date: moment().format('DD-MM-YYYY'),
        level_id: null,
        class_id: null,
        topic_id: null,
        acps_id: null,
        student_id_list: [],
        staff_id_list: [],
        promotion: null
      },
      newRow: {
        committee_name: null,
        remark: null
      }
    }
  },
  created () {
    this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('thesis', ['editData'])
  },
  methods: {
    ...mapActions('thesis', [
      'getTopic',
      'getTeacher',
      'getYear',
      'getSubProgram',
      'getLevel',
      'getTerm',
      'getClass',
      'getStudent'
    ]),
    async fetchData () {
      this.loading = true
      await this.getTopic().then(response => {
        this.topics = response.data.map(el => ({
          value: el.topic_id,
          label: el.topic_name_en
        }))
      })
      await this.getTeacher().then(response => {
        this.teacherLists = response.data.map(el => ({
          value: el.teacher_id,
          label: el.fname_foreign + ' ' + el.lname_foreign
        }))
      })
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getSubProgram().then(response => {
        this.sub_programs = response.data.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
        this.model.acps_id = this.editData.academic_class.acps_id
      })
    },
    acYearChange () {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.level_id = []
      this.model.class_id = []
    },
    async onSubChange (acps_id) {
      this.model.level_id = []
      this.model.class_id = []
      this.levels = []
      this.filterSub = true
      await this.getLevel({
        filter: {
          acps_id: acps_id
        }
      })
        .then(response => {
          this.levels = response.data.map(el => ({
            value: el.level_id,
            label: el.level_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterSub = false
        })
    },
    async levelChange (level_id) {
      this.filterLevel = true
      this.model.ac_term_id = null
      await this.getTerm({
        filter: {
          level_id: level_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : null)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })
    },
    acTermChange (ac_term_id) {
      this.filterClass = true
      this.model.class_id = null
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
          required_thesis: true
        }
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterClass = false
        })
    },
    fetStudentList (params) {
      this.student_search = true
      this.getStudent(params)
        .then(response => {
          let data = []
          response.data.forEach(el => {
            let { level, sub_program, ...resource } = el
            data.push({ ...level, ...sub_program, ...resource })
          })

          this.studentResources = orderBy(
            data,
            ['level_name_foreign', 'acps_name_foreign', 'card_number'],
            ['desc']
          )
        })
        .finally(() => {
          this.student_search = false
        })
    },
    onClassChange () {
      this.model.student_id_list = []
    },
    addNewRow () {
      this.model.staff_id_list.push(_.clone(this.newRow))
    },
    removeRow (item) {
      this.model.staff_id_list.splice(this.model.staff_id_list.indexOf(item), 1)
    },
    onCheangeClass () {
      this.model.student_id_list = []
    },
    update () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('thesis/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'thesis' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    async setEditData () {
      if (!_.isEmpty(this.editData)) {
        await this.onSubChange(this.editData.academic_class.acps_id)
        await this.getLevel(this.editData.academic_class.acps_id)
        await this.acTermChange(this.editData.academic_class.ac_term_id)
        await this.getClass(this.editData.academic_class.ac_term_id)
        await this.levelChange(this.editData.academic_class.level_id)
        ;(this.model.start_date = moment(this.editData.start_date).format(
          'DD-MM-YYYY'
        )),
          (this.model.end_date = moment(this.editData.end_date).format(
            'DD-MM-YYYY'
          )),
          (this.model.ac_year_id = this.editData.academic_class.ac_year_id),
          (this.model.registration_date = moment(
            this.editData.registration_date
          ).format('DD-MM-YYYY')),
          (this.model.acps_id = this.editData.academic_class.acps_id),
          (this.model.topic_id = this.editData.thesis_topic.topic_id),
          (this.model.registration_type = this.editData.registration_type),
          (this.model.ac_term_id = this.editData.academic_class.ac_term_id),
          (this.model.teacher_id = this.editData.teacher.teacher_id),
          (this.model.class_id = this.editData.academic_class.class_id),
          (this.model.staff_id_list = []),
          (this.model.student_id_list = []),
          (this.model.thesis_reg_id = this.editData.thesis_reg_id),
          (this.model.presentation_date = moment(
            this.editData.presentation_date
          ).format('DD-MM-YYYY'))
        this.model.level_id = []
        if (this.editData.academic_class.level_id) {
          this.editData.academic_class.level_id.split(',').map(el => {
            this.model.level_id.push(parseInt(el))
          })
        }
        this.editData.thesis_registration_members.forEach(el => {
          this.model.student_id_list.push({
            student_id: el.student_id,
            is_main_class: el.is_main_class,
            is_leader: parseInt(el.is_leader) ? true : false
          })
        })
        this.editData.committees.forEach(el => {
          this.model.staff_id_list.push(el)
        })
      }
    }
  },
  watch: {
    'model.class_id': function () {
      this.getStudent({
        filter: {
          not_in_enrollmented_class: this.model.class_id
        }
      })
    }
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 30.8vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
